import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleOAuthCallback, redirectToHostedUI } from '../utils/cognitoAuth';
import { useAuth } from '../context/AuthContext';

export default function CallbackPage() {
  const navigate           = useNavigate();
  const { refreshSession } = useAuth();
  const [error, setError]  = useState(null);

  useEffect(() => {
    let target = '/dashboard';
    handleOAuthCallback()
      .then(({ returnPath }) => { target = returnPath || '/dashboard'; return refreshSession(); })
      .then(() => navigate(target, { replace: true }))
      .catch(err => {
        const msg = err.message || '';
        if (msg === 'login_required' || msg === 'access_denied') {
          // Silent SSO check failed (no existing Cognito session) — send the
          // user back to the branded login screen instead of straight to
          // Cognito, so Register/Forgot links stay reachable.
          navigate('/login', { replace: true });
        } else {
          setError(msg || 'Sign-in failed');
        }
      });
  }, [navigate, refreshSession]);

  if (error) return (
    <div className="loading-screen" style={{ flexDirection: 'column', gap: 16 }}>
      <p>Sign-in error: {error}</p>
      <button
        className="login-signin-btn"
        style={{ maxWidth: 200 }}
        onClick={() => redirectToHostedUI()}
      >
        Try again
      </button>
    </div>
  );

  return <div className="loading-screen"><div className="spinner" /></div>;
}
